import {} from "../../request/api";
const state = {
    drawMap: {
        drawControl: null, //手绘控件
        drawObj: null, // 手动绘制对象
        drawLayerGrounp: new L.FeatureGroup(), // 计划图形图层组
        realDrawLayerGrounp: new L.FeatureGroup(), // 实际图形图层组
    },

};
const mutations = {
    changeMap(state) {
        state.drawMap.drawLayerGrounp.addTo(map);
        state.drawMap.realDrawLayerGrounp.addTo(map);

    },
    startDataDraw(state, drawLayer) {
        // 添加到图层组
        state.drawMap.drawLayerGrounp.addLayer(drawLayer);
        if (drawLayer.getBounds) {
            map.fitBounds(drawLayer.getBounds(), {
                maxZoom: 8
            });
        }
    },
    startDataDrawAirspace(state, drawLayer) {
        // 添加到图层组
        state.drawMap.drawLayerGrounp.addLayer(drawLayer);
    },

    startRealDataDraw(state, drawLayer) {
        state.drawMap.realDrawLayerGrounp.addLayer(drawLayer);

    },
    stopRealDraw(state) {
        if (state.drawMap.realDrawLayerGrounp) {
            state.drawMap.realDrawLayerGrounp.clearLayers();
        }
    },
    stopDraw(state) {
        // 删除全部绘制的图层
        if (state.drawMap.drawLayerGrounp) {
            state.drawMap.drawLayerGrounp.clearLayers();
        }
    },
    fly(state, latLng) {
        //lng经度  lat纬度
        map.flyTo(L.latLng(latLng[0], latLng[1]));
    },
};
const actions = {
    initMapDataAction(context) {
        context.commit('changeMap');
    },
    startDataDrawAction(context, drawLayer) {
        context.commit('startDataDraw', drawLayer);
    },
    flyAction(context, latLng) {
        context.commit('fly', latLng);
    },
    stopDrawAction(context) {
        context.commit('stopDraw');
    }
};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}